import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import Form from 'components/Form';
import Button from 'components/Button';
import TextInput from 'components/TextInput';
import ListHeader from 'components/ListHeader';
import MainContainer from 'components/MainContainer';
import { createUser } from 'api/users';

const presence = {
    allowEmpty: false,
    message: "^campo obbligatorio"
}

const constraints = {
    name: { presence },
    email: { presence },
    password: { presence },
    confirmPassword: {
        presence,
        equality: {
            attribute: "password",
            message: "^le password non coincidono"
        }
    }
}

export default function CreaUtente() {

    const navigate = useNavigate();

    const { mutate, status } = useMutation({
        mutationFn: createUser,
        onSuccess: ({data}) => {
            return navigate(`/impostazioni/utenti/${data._id}`)
        },
        onError: (error) => {
            console.error(error);
        }
    })


    function onCreateHandler(data) {
        data = {
            ...data,
            emails: [{ address: data.email }]
        }
        return mutate({
            data
        })
    }


    return (
        <>
            <MainContainer>
                <div className='pt-10 pb-5'>
                    <ListHeader
                        backLink="/impostazioni/utenti"
                        title="Crea utente"
                    />
                </div>

                <div className='bg-white p-8 rounded-[40px]'>
                    <Form onSubmit={onCreateHandler} constraints={constraints}>
                        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4 w-full'>
                            <TextInput
                                name="name"
                                label="Nome"
                                placeholder="Inserisci il nome"
                            />
                            <TextInput
                                name="email"
                                label="Email"
                                placeholder="Inserisci l'email"
                                required
                            />
                            <TextInput
                                type="password"
                                name="password"
                                label="Password"
                                placeholder="Inserisci la password"
                                required
                            />
                            <TextInput
                                type="password"
                                name="confirmPassword"
                                label="Conferma Password"
                                placeholder="Conferma la password"
                                required
                            />
                        </div>

                        <div className='flex'>
                            <Button submit status={status}>Crea utente</Button>
                        </div>
                    </Form>
                </div>
            </MainContainer>
        </>
    )
}
